export interface OverrideFeatureFlagRequest {
  flags: Record<string, boolean>
}
